
      import API from "!../../../../../../procollege/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../../../../../procollege/node_modules/style-loader/dist/runtime/styleDomAPI.js";
      import insertFn from "!../../../../../../procollege/node_modules/style-loader/dist/runtime/insertBySelector.js";
      import setAttributes from "!../../../../../../procollege/node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../../../../../../procollege/node_modules/style-loader/dist/runtime/insertStyleElement.js";
      import styleTagTransformFn from "!../../../../../../procollege/node_modules/style-loader/dist/runtime/styleTagTransform.js";
      import content, * as namedExport from "!!../../../../../../procollege/node_modules/css-loader/dist/cjs.js!../../../../../../procollege/node_modules/vue-loader/dist/stylePostLoader.js!../../../../../../procollege/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-1.use[2]!../../../../../../procollege/node_modules/vue-loader/dist/index.js??ruleSet[1].rules[5].use[0]!./AdditionalSection.vue?vue&type=style&index=0&id=92936a1e&lang=css";
      
      

var options = {};

options.styleTagTransform = styleTagTransformFn;
options.setAttributes = setAttributes;

      options.insert = insertFn.bind(null, "head");
    
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../../../../../procollege/node_modules/css-loader/dist/cjs.js!../../../../../../procollege/node_modules/vue-loader/dist/stylePostLoader.js!../../../../../../procollege/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-1.use[2]!../../../../../../procollege/node_modules/vue-loader/dist/index.js??ruleSet[1].rules[5].use[0]!./AdditionalSection.vue?vue&type=style&index=0&id=92936a1e&lang=css";
       export default content && content.locals ? content.locals : undefined;
